import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import ClubInfoModal from './ClubInfoModal';
import PassNotFound from './PassNotFound';
import Under18Modal from './Under18Modal';
import ProductDetails from './ProductDetails';
import Timeout from './Timeout';
import IFrameModal from './IFrame';
import './Modal.css';




class DGRModal extends Component {
    constructor(props){
        super(props);
        this.modalClose = this.modalClose.bind(this)
        this.outsideClick = this.outsideClick.bind(this)
    }

    modalClose(e){
        e.preventDefault();
        e.stopPropagation();
        //clear children
        this.props.DGRModalStore.setSection('nothing')
        this.props.DGRModalStore.closeModal()
    };

    outsideClick(e){
        //close modal from oustide click
        if (e.target.className === 'modal'){
            if (this.props.DGRModalStore.closeHidden === false){
                this.props.DGRModalStore.setSection('nothing')
                this.props.DGRModalStore.closeModal()
            }
        }
    }

    modalItem(){
        switch (this.props.DGRModalStore.section){
            case "productDetails":
                return (<ProductDetails history={this.props.history}/>)
            case "iframe":
                return (<IFrameModal history={this.props.history}/>)
            case "passNotFound":
                return (<PassNotFound history={this.props.history}/>)
            case "under18Modal":
                return (<Under18Modal history={this.props.history}/>)
            case "timeout":
                return (<Timeout/>)
            case "club_number":
                return (<ClubInfoModal/>)
            default:
                return (<div>default</div>)
        }

    }

    render() {
        const { closeHidden, isOpen  } = this.props.DGRModalStore;
        const styles = {
            modalVisibility: () => {
                if (isOpen) {
                    return {
                        display: 'block',
                    }
                }else{
                    return {
                        display: 'none',
                    }
                }
            },
			closeVisibility: () => {
                if (closeHidden) {
                    return {
                        display: 'none',
                    }
                }else{
                    return {
                        display: 'block',
                    }
                }
            }
        }
        return (
            <div
                className="modal"
                style = {styles.modalVisibility()}
                onClick = { this.outsideClick }
            >
                <div className="modalContent">
                    <button
                        className="closeModalButton"
                        style = {styles.closeVisibility()}
                        onClick={this.modalClose}
                    >
                        <span className="modalClose">&times;</span>
                    </button>
                    {this.modalItem()}
                </div>
            </div>
        );
    }
}

DGRModal  = inject('DGRModalStore')(observer(DGRModal))
export default DGRModal



// WEBPACK FOOTER //
// ./src/components/DGR/Modal/Modal.js